import React from 'react';
import { KeyValueMap } from '../KeyValueMap';
import { ActionType } from '../components/ActionType';
import ResponsiveToolbar from '../components/ResponsiveToolbar';
import { Icons } from '../icons/Icons';

export const paragraphTypes: KeyValueMap<string, ActionType> = {
    paragraph: { label: 'lexical.heading.normal' },
    h1: { label: 'lexical.heading.h1' },
    h2: { label: 'lexical.heading.h2' },
    h3: { label: 'lexical.heading.h3' },
    h4: { label: 'lexical.heading.h4' },
    h5: { label: 'lexical.heading.h5' },
    h6: { label: 'lexical.heading.h6' },
    // code: 'Code Block',
    quote: { label: 'lexical.heading.quote' }
};

export default ({ blockType, setBlockType, disabled }) => {
    return (
        <ResponsiveToolbar
            multi={false}
            disabled={disabled}
            isSmall={true}
            selected={blockType}
            onSelect={setBlockType}
            options={paragraphTypes}
            icon={Icons.Abc}
        />
    );
};
